"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mapTo = require("rxjs/operators/mapTo");

var _actions = require("settings-ui-sdk/CanSpamSettings/actions");

var _CreateFooter = _interopRequireDefault(require("../../stagedObjects/CreateFooter"));

var resetCreateFooterStagingOnCreate = function resetCreateFooterStagingOnCreate($action) {
  return $action.ofType(_actions.CreateCanSpamSettingActionTypes.SUCCESS).pipe((0, _mapTo.mapTo)(_CreateFooter.default.resetChangesToStagedObject()));
};

var _default = resetCreateFooterStagingOnCreate;
exports.default = _default;
module.exports = exports.default;